import React from 'react';
import { GiftIcon, CheckIcon } from 'lucide-react';
import { CtaButton } from './CtaButton';
import { SectionHeading } from './SectionHeading';
import { bonuses } from '../data/bonuses';
export function BonusesSection() {
  return <section className="w-full bg-canvas px-5 py-16 sm:py-20" data-id="element-20" data-mp="vuh7e1j2mmg7">
      <div className="mx-auto max-w-3xl" data-id="element-21" data-mp="qt9y1y1a5f7f">
        <div className="flex justify-center" data-id="element-22" data-mp="qs8ef5677ke3">
          <span className="inline-flex items-center gap-2 rounded-full bg-alert-600 px-4 py-1.5 font-display text-base font-bold uppercase tracking-wider text-white" data-id="element-23" data-mp="14tb0vj13uwpj">
            <GiftIcon className="h-4 w-4" aria-hidden="true" data-id="element-24" data-mp="zsew738xj6j2" />
            Included free today
          </span>
        </div>
        <div className="mt-4" data-id="element-25" data-mp="19kkn09ng3hwo">
          <SectionHeading title={<>
                5 exclusive <span className="text-electric-600" data-id="element-27" data-mp="1njkd7lqlw4uy">professional bonuses</span>
              </>} subtitle="Five additional tools designed to complement the six-volume system." data-id="element-26" data-mp="19lc98tv5k3aa" />
        </div>

        <div className="mt-12 space-y-10" data-id="element-28" data-mp="3prdbm17v8lsv">
          {bonuses.map(b => <article key={b.number} className="-mx-5 overflow-hidden bg-white sm:mx-0 sm:rounded-3xl sm:shadow-sm" data-id="element-29" data-mp="3trdupz5wtl69">
              <div className="flex items-center justify-between gap-3 bg-navy-900 px-5 py-3" data-id="element-30" data-mp="2kkpmk7zx1wg">
                <span className={`rounded-lg px-3 py-1 font-display text-lg font-extrabold uppercase ${b.badgeClass}`} data-id="element-31" data-mp="7lqlgqwyd5a7">
                  Bonus #{b.number}
                </span>
                <span className="text-right text-[13px] font-semibold text-slate-300" data-id="element-32" data-mp="gkvj7v0owulb">
                  Value <s className="text-alert-500" data-id="element-33" data-mp="lcdnary0fbai">{b.value}</s>{' '}
                  <span className="font-display text-lg font-extrabold uppercase text-cta-400" data-id="element-34" data-mp="le6se2sz5nge">Free</span>
                </span>
              </div>
              <img src={b.image} alt={`Bonus #${b.number}: ${b.title}`} className="block w-full" loading="lazy" data-id="element-35" data-mp="vb2thngjn7ax" />
              <div className="px-5 pb-8 pt-6 sm:px-8" data-id="element-36" data-mp="10afpoytb1qq6">
                <h3 className="font-display text-[32px] font-extrabold uppercase leading-[1.02] text-ink" data-id="element-37" data-mp="al8ol2wiy5gf">{b.title}</h3>
                <p className="mt-2 text-[15px] font-semibold text-ink" data-id="element-38" data-mp="5mnwxrvc8u3l">
                  Proposed reference value: <s className="text-alert-600" data-id="element-39" data-mp="kbk4lnthg53o">{b.value}</s> —{' '}
                  <span className="text-cta-700" data-id="element-40" data-mp="kcv8dnmxhcus">Included FREE today</span>
                </p>
                <div className="mt-4 space-y-3 text-[16px] leading-relaxed text-muted" data-id="element-41" data-mp="fi8wzkgujkap">
                  {b.paragraphs.map(p => <p key={p} data-id="element-42" data-mp="od5ceur5tt70">{p}</p>)}
                </div>
                {b.items && <>
                    <p className="mt-4 text-[16px] font-semibold text-ink" data-id="element-43" data-mp="139e85mbudoeo">{b.listIntro}</p>
                    <ul className="mt-3 grid gap-x-6 gap-y-2 sm:grid-cols-2" data-id="element-44" data-mp="yc4lgefu7quj">
                      {b.items.map(item => <li key={item} className="flex gap-2.5 text-[15px] text-ink" data-id="element-45" data-mp="353dj26l1y3qu">
                          <CheckIcon className="mt-0.5 h-5 w-5 shrink-0 text-cta-600" strokeWidth={3} aria-hidden="true" data-id="element-46" data-mp="3040wlmy3eyos" />
                          <span data-id="element-47" data-mp="1fmi02fo7vw18">{item}</span>
                        </li>)}
                    </ul>
                  </>}
                {b.note && <p className="mt-4 text-[14px] italic leading-relaxed text-muted" data-id="element-48" data-mp="15tt0oj5xy8m9">{b.note}</p>}
              </div>
            </article>)}
        </div>

        <CtaButton label="I want all 5 bonuses free" className="mt-12" data-id="element-49" data-mp="wt4mnogjs89d" />
      </div>
    </section>;
}